const utmTags = new URLSearchParams({
  utm_source: "indietabletopclub",
  utm_medium: "referral",
  utm_campaign: "eternolapp",
});

export const links = {
  fathom: `https://usefathom.com`,
  electi: `https://www.electi-studio.com/?${utmTags}`,
  eternol: `https://www.electi-studio.com/eternol-15mm?${utmTags}`,
  arturmuller: `http://arturmuller.com?${utmTags}`,
  itc: `https://indietabletop.club?${utmTags}`,
  roadmap: `https://trello.com/b/8LLZ66qy/eternol`,
  discord: `https://discord.gg/HGBpKxK5Fy`,
};
